import React from 'react';
import * as ContextMenu from '@radix-ui/react-context-menu';
import "./InputTable.css";



const ContextMenuDemo = (props) => {
    const [isHidden, setIsHidden] = React.useState(false);
    const { handleHide, handleShow, name, index} = props;
    

    const toggleVisibility = () => {
        setIsHidden(prevIsHidden => {
            if (prevIsHidden) {
                handleShow(index);
            } else {
                handleHide(index);
            }
            return !prevIsHidden;
        });
    };

    return (
        <ContextMenu.Root>
            <ContextMenu.Trigger>{ name }</ContextMenu.Trigger>
            <ContextMenu.Content>
                <ContextMenu.Item>
                    <button onClick={toggleVisibility} class="context-menu-button">{isHidden ? 'Show' : 'Hide'}</button>
                </ContextMenu.Item>
            </ContextMenu.Content>
        </ContextMenu.Root>
    );
};

export default ContextMenuDemo;